"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var storage = __importStar(require("../utils/storage"));
var lodash_1 = require("lodash");
/**
 * Checks if user has specified permission.
 *
 * @param {String} permission Permission to check
 */
exports.hasPermission = function (permission) { return exports.hasAnyPermission([permission]); };
/**
 * Checks if user has any of the permissions.
 *
 * @param {Array} permissions List of permission to check
 */
exports.hasAnyPermission = function (permissions) {
    var token = storage.get('token');
    if (token && token !== 'null') {
        var decoded = jwt_decode_1.default(token);
        var authorities = decoded.authorities, exp = decoded.exp;
        if (new Date().getTime() > exp * 1000) {
            return false;
        }
        return permissions ? lodash_1.intersection(authorities, permissions).length !== 0 : true;
    }
    return false;
};
/**
 * Returns id of user stored in token.
 *
 * @returns Id of user
 */
exports.getUserId = function () {
    var token = storage.get('token');
    if (token && token !== 'null') {
        var decoded = jwt_decode_1.default(token);
        var sub = decoded.sub, exp = decoded.exp;
        if (new Date().getTime() > exp * 1000) {
            return null;
        }
        return sub;
    }
    return null;
};
//# sourceMappingURL=tokenApi.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/api/tokenApi.js
// module id = 2216
// module chunks = 0